// ! TODO: move to wag-react
import React from "react";
import { Box, BoxProps } from "@waglabs/box-next";
export type ContainerProps = BoxProps;
export const Container = (props: ContainerProps) => <Box m="0 auto" maxWidth={['100%', '688px', '1120px', '1600px']} px={['16px', '24px']} width={1} {...props} />;